import { ALL_PRODUCT_TYPES } from "constants/chart.constants";
import { EvaChart } from "constants/charts.enums";

export const checkVrrProductWithCompatibleChartType = (
  chartType: EvaChart,
  product: string
): boolean => {
  if (
    chartType !== EvaChart.RateDate &&
    (product === ALL_PRODUCT_TYPES.VRR.label || product === ALL_PRODUCT_TYPES.IVRR.label)
  ) {
    return true;
  }
  return false;
};
